var map = {
  "./cs.json": [
    "blx",
    [
      "9r"
    ]
  ],
  "./en.json": [
    "qv",
    [
      "w1"
    ]
  ],
  "./pl.json": [
    "HOV",
    [
      "xq"
    ]
  ],
  "./ru.json": [
    "mg9",
    [
      "s4"
    ]
  ],
  "./tr.json": [
    "Hx",
    [
      "5q"
    ]
  ],
  "./ja.json": [
    "hLT",
    [
      "b6"
    ]
  ],
  "./zh.json": [
    "JeV",
    [
      "7x"
    ]
  ],
  "./pt-br.json": [
    "t0T",
    [
      "3ux"
    ]
  ],
  "./de.json": [
    "a8g",
    [
      "o6"
    ]
  ],
  "./es.json": [
    "YP",
    [
      "uen"
    ]
  ],
  "./fr.json": [
    "pCG",
    [
      "rpv"
    ]
  ],
  "./it.json": [
    "sf",
    [
      "mi"
    ]
  ],
  "./ko.json": [
    "F9",
    [
      "z4"
    ]
  ],
  "./pt.json": [
    "Po",
    [
      "lf"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "FN";
module.exports = __rspack_async_context;
